import { render, staticRenderFns } from "./RowAccordion.vue?vue&type=template&id=0b91de81"
import script from "./RowAccordion.vue?vue&type=script&lang=js"
export * from "./RowAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports